__turbopack_context__.v({
  "contentWrpOverflowFix": "styles-module-scss-module__Zg4aHa__contentWrpOverflowFix",
  "homePageContainer": "styles-module-scss-module__Zg4aHa__homePageContainer",
  "homePageContentHolder": "styles-module-scss-module__Zg4aHa__homePageContentHolder",
  "pageContainer": "styles-module-scss-module__Zg4aHa__pageContainer",
  "pageContentHolder": "styles-module-scss-module__Zg4aHa__pageContentHolder",
  "staticPageContentHolder": "styles-module-scss-module__Zg4aHa__staticPageContentHolder",
});
